// extracted by mini-css-extract-plugin
export default {"tableRow":"BatchTableRow_tableRow__IAm4K"};